import { trpc } from '@/main'
import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'

// /orgs/$orgId (org selected, no group): OrgsLayout shows the groups panel; this index match renders
// nothing into the (collapsed) detail Outlet. It owns the `getGroups` prefetch for the org-selected state
// — the `orgs.$orgId` Outlet-only layout carries no loader (see AGENTS.md), so this is the route that
// warms the groups panel on a hard reload of `/orgs/$orgId`. Selecting a group navigates to
// `/orgs/$orgId/groups/$groupId/report`.
export const Route = createFileRoute('/_app/orgs/$orgId/')({
  context: ({ params }) => ({ orgGroupsQueryOptions: trpc.orgs.getGroups.queryOptions(params.orgId) }),
  loader: ({ context }) => {
    context.queryClient.query(context.orgGroupsQueryOptions).catch(noop)
  },
  component: () => null,
})
